import { graphQuery, graphMutation } from '@services/commService';

export const getAllBusinessUnits = async () => {
  const query = `
  {
    allBusinessUnits {
      id
      name
    }
  }
  `;
  const res = await graphQuery(query, true);
  return res.data;
};

export const updateUserBusinessUnits = async (userId, businessUnits) => {
  const normalizedBusinessUnits = Array.isArray(businessUnits)
    ? businessUnits.filter(Boolean).slice(0, 1)
    : [];
  const businessUnitsArg = normalizedBusinessUnits.map((businessUnitId) => `"${businessUnitId}"`).join(', ');
  const mutation = `
    mutation {
      updateUserBusinessUnits(userId: "${userId}", businessUnits: [${businessUnitsArg}]) {
        id
        businessUnits
      }
    }
  `;
  const { data } = await graphMutation(mutation, {}, true);
  return data;
};